import React from 'react';

export const DineoraMark = ({ className = 'w-[0.72em] h-[0.72em]' }) => (
  <img src="/dineora-icon.png" alt="" className={`${className} rounded-[22%]`} aria-hidden="true" />
);

const Logo = ({ className = 'h-7', testId = 'dineora-logo' }) => (
  <a href="/" data-testid={testId} aria-label="DineOra home" className={`flex items-center ${className}`}>
    <img src="/logo-dineora.png" alt="DineOra" className="h-full w-auto" />
  </a>
);

export default Logo;
